__turbopack_context__.v({
  "empty": "WShopLatestProducts-module__fK6Vwq__empty",
  "header": "WShopLatestProducts-module__fK6Vwq__header",
  "heading": "WShopLatestProducts-module__fK6Vwq__heading",
  "productList": "WShopLatestProducts-module__fK6Vwq__productList",
  "root": "WShopLatestProducts-module__fK6Vwq__root",
  "showAllBtn": "WShopLatestProducts-module__fK6Vwq__showAllBtn",
});
